import { render } from "./formselect2.vue?vue&type=template&id=4288b695"
import script from "./formselect2.vue?vue&type=script&lang=js"
export * from "./formselect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__